import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-disclaimer">
            <p>Este test es una herramienta de autorreflexión, no un instrumento diagnóstico.</p>
          </div>
          
          <div className="footer-copyright">
            <p>© {currentYear} Jesús Sagrario - Psicólogo Sanitario</p>
          </div>
          
          <div className="footer-links">
            <Link to="/privacidad" className="footer-link">Privacidad</Link>
            <span className="footer-separator">|</span>
            <Link to="/terminos" className="footer-link">Términos</Link>
            <span className="footer-separator">|</span>
            <Link to="/contacto" className="footer-link">Contacto</Link>
            <span className="footer-separator">|</span>
            <Link to="/cookies" className="footer-link">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
